import Vue from 'vue'

const userRole = {
  state: {
    userRoles: [],
    selectedUserRole: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    userRoles(state) {
      return state.userRoles
    },
    selectedUserRole(state) {
      return state.selectedUserRole
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    userRoles(state, payload) {
      state.userRoles = payload
    },
    selectedUserRole(state, payload) {
      state.selectedUserRole = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedUserRole(context, payload) {
      context.commit('selectedUserRole', payload)
    },
    loadUserRoles(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'UserRole'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('userRoles', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedUserRole(context, payload) {
      if (
        context.state.selectedUserRole &&
        context.state.selectedUserRole.UserID
      ) {
        context.dispatch(
          'loadSelectedUserRole',
          context.state.selectedUserRole.UserID
        )
      }
      if (
        context.state.selectedUserRole &&
        context.state.selectedUserRole.RoleID
      ) {
        context.dispatch(
          'loadSelectedUserRole',
          context.state.selectedUserRole.RoleID
        )
      }
    },
    loadSelectedUserRole(context, payload) {
      if (
        context.state.selectedUserRole &&
        context.state.selectedUserRole.UserID != payload
      ) {
        context.commit('selectedUserRole', {})
      }
      if (
        context.state.selectedUserRole &&
        context.state.selectedUserRole.RoleID != payload
      ) {
        context.commit('selectedUserRole', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'UserRole/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedUserRole', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createUserRole(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `UserRole`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'user role created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadUserRoles')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default userRole
